module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"projects":"Projekty","users":"Uživatelé","system":"Systém","current":"stávající"},"de":{"projects":"Projekte","users":"Benutzer","system":"System","current":"aktuell"},"es":{"projects":"Proyectos","users":"Usuarios","system":"Sistema","current":"actual"},"fr":{"projects":"Projets","users":"Utilisateurs","system":"Système","current":"actuel"}}')
  delete Component.options._Ctor
}
